import React from 'react';
import {render} from 'react-dom';

import {isGolosNarodaActive, isGolosNarodaActiveWithoutWidget} from '../../../golos/helpers';

import {GolosNarodaWidget} from '.';

const renderGolosNarodaWidget = ({containerElement}) => {
  if (!containerElement) {
    return;
  }

  if (!isGolosNarodaActive || isGolosNarodaActiveWithoutWidget) {
    return;
  }

  const type = containerElement.dataset.type;

  render(<GolosNarodaWidget widgetType={type} />, containerElement);
};

export {renderGolosNarodaWidget};
